import { Component, inject, OnInit } from "@angular/core";
import { NxCell } from "qlik";
import { Title } from "@angular/platform-browser";
import { FilterComponent } from "../felles/components/filter/filter.component";
import { KpitabellComponent } from "../felles/components/kpitabell/kpitabell.component";
import { KommunefilterComponent } from "../felles/components/kommunefilter/kommunefilter.component";
import { QlikService } from "../felles/services/qlik.service";
import { AccordionComponent } from "@husbanken/designsystem-angular-core";
import { AccordionElementComponent, HjelpetekstComponent } from "@husbanken/designsystem-angular-core";
import { GrafComponent } from "../felles/components/graf/graf.component";

@Component({
  selector: "stat-bostotte",
  templateUrl: "./bostotte.component.html",
  imports: [FilterComponent, KpitabellComponent, KommunefilterComponent, AccordionComponent, AccordionElementComponent, HjelpetekstComponent, GrafComponent],
})
export class BostotteComponent implements OnInit {
  statistikkType = "Utbetaling";
  graferValgt = "soknader";
  objectKeys = Object.keys;
  valgtFilter: { [key: string]: NxCell[] } = null;
  noSelections: true;
  grafIderForSoknad: string[] = [];
  grafIderForBelop: string[] = [];
  grafIderForAvslag: string[] = [];
  grafIderForUtbetalt: string[] = [];
  grafIderForGjennomsnitt: string[] = [];
  kpiListeForSoknad: string[] = [];
  kpiListeForUtbetaling: string[] = [];
  kpiListeForAvslag: string[] = [];

  typeTekst = {
    Søknad: {
      soknader: ["Antall husstander", "Viser antall husstander som har søkt om å få bostøtte for en gitt periode (termin), uavhengig av vedtaksutfall."],
    },
    Terminutbetaling: {
      soknader: [
        "Antall husstander",
        "Viser antall husstander som har fått utbetalt bostøtte for en gitt periode (termin). Viser perioden de søkte bostøtte for, ikke selve utbetalingsmåneden.",
      ],
      belop: ["Utbetalt beløp", "Viser totalt utbetalt beløp for en gitt periode (termin). Viser perioden det ble søkt om bostøtte for, ikke selve utbetalingsmåneden. "],
      utbetalt: [
        "Gjennomsnitt beløp",
        "Viser gjennomsnittlig utbetalt beløp for en gitt periode (termin). Viser perioden det ble søkt om bostøtte for, ikke selve utbetalingsmåneden. ",
      ],
    },
    Utbetaling: {
      soknader: [
        "Antall husstander",
        "Viser antall husstander som har fått utbetalt bostøtte for en gitt periode (utbetalingsdato). Tallene er knyttet til perioden bostøtten ble utbetalt. ",
      ],
      belop: ["Utbetalt beløp", "Viser totalt utbetalt beløp for en gitt periode (utbetalingsdato). Tallene er knyttet til perioden bostøtten ble utbetalt."],
      utbetalt: ["Gjennomsnitt beløp", "Viser gjennomsnittlig utbetalt beløp for en gitt periode (utbetalingsdato). Tallene er knyttet til perioden bostøtten ble utbetalt."],
    },
    Avslag: {
      soknader: ["Antall avslag", "Viser antall husstander som har fått avslag på søknaden om bostøtte for en gitt periode (termin)."],
    },
  };

  qlikService = inject(QlikService);
  titleService = inject(Title);

  constructor() {
    this.qlikService.resetFilter();
    this.qlikService.setFylkeFilter();
    this.qlikService.setFilter("VirkemiddelKode", "BOSTØTTE", false, true);
    this.qlikService.setFilter("TypeTilstand", "Utbetaling", false, true);
  }

  ngOnInit() {
    this.titleService.setTitle("Statistikk - Bostøtte - Husbanken");
    this.grafIderForSoknad = ["bst-ant-saker-pr-fylke", "bst-ant-saker", "bst-esøknader-pr-fylke", "bst-andel-eie-leie"];
    this.grafIderForUtbetalt = ["bst-ant-saker-pr-fylke", "bst-ant-saker", "bst-andel-eie-leie", "bst-andel-barnefamilier"];
    this.grafIderForBelop = ["bst-beløp-pr-fylke", "bst-beløp", "bst-beløp-eie-leie", "bst-beløp-andel-barnefamilier"];
    this.grafIderForGjennomsnitt = ["bst-gjennomsnitt-beløp-pr-fylke", "bst-gjennomsnitt-beløp", "bst-gjennomsnitt-beløp-eie-leie", "bst-gjennomsnitt-beløp-andel-barnefamilier"];
    this.grafIderForAvslag = ["bst-ant-saker-pr-fylke", "bst-ant-saker", "bst-andel-eie-leie", "bst-avslagsårsaker"];
    this.kpiListeForSoknad = ["BST Antall saker", "BST Andel barnefamilier", "BST Andel elektroniske søknader", "BST Gjennomsnittlig inntekt", "BST Gjennomsnittlig boutgift"];
    this.kpiListeForUtbetaling = [
      "BST Antall saker",
      "BST Andel barnefamilier",
      "BST Andel med boutgifter over tak",
      "BST Gjennomsnittlig inntekt",
      "BST Gjennomsnittlig boutgift",
      "BST Gjennomsnittlig bostøtte",
      "BST Utbetaling bostøtte",
    ];
    this.kpiListeForAvslag = ["BST Antall avslag", "BST Antall vedtak totalt", "BST Avslagsprosent"];
  }

  public filterTilstand(filter) {
    this.qlikService.setFilter("TypeTilstand", filter, false, true);
    this.statistikkType = filter;
  }

  selectedRadio(event) {
    this.graferValgt = event.target.value;
  }

  filterVisning(event) {
    this.valgtFilter = event;
  }

  hentSelectedRadioLabel(): string {
    if (this.statistikkType === "Utbetaling") {
      return this.typeTekst[this.statistikkType][this.graferValgt][0];
    } else if (this.statistikkType === "Avslag") {
      return "Antall avslag";
    } else {
      return "Antall saker";
    }
  }
}
